import * as React from 'react';
import { createContext, useContext } from 'react';

import { isCourseOutlineTimeEstimatesEnabled } from 'bundles/course-frame/utils/epicUtils';

export type CourseMembershipContextType = {
  enrollmentTime: number | undefined;
  showTimeEstimates: boolean;
};

export const CourseMembershipContext = createContext<CourseMembershipContextType | undefined>(undefined);

type Props = {
  enrollmentTime: number | undefined;
};

export const CourseMembershipContextProvider = (props: React.PropsWithChildren<Props>) => {
  const { children, enrollmentTime } = props;
  const showTimeEstimates = isCourseOutlineTimeEstimatesEnabled(enrollmentTime);
  const contextValue: CourseMembershipContextType = {
    enrollmentTime,
    showTimeEstimates,
  };
  return <CourseMembershipContext.Provider value={contextValue}>{children}</CourseMembershipContext.Provider>;
};

export const useCourseMembershipContext = (): CourseMembershipContextType => {
  const context = useContext(CourseMembershipContext);
  if (!context) {
    throw new Error('useCourseMembershipContext must be used within an CourseMembershipContextProvider');
  }
  return context;
};
